import React from "react";
import {FlexAutoScroll} from "./StyleComponents";
import {inject, observer} from "mobx-react";

const StepperContent = inject("uiStore")(observer(({children, uiStore, step, ...othersProps}: any) => {
    return step === uiStore.stepperState ?
        (<FlexAutoScroll {...othersProps}>
            {React.cloneElement(children, othersProps)}
        </FlexAutoScroll>)
        : null;
}));

export default StepperContent;
